import React from 'react';

import styles from './BatchDetailsTableHeader.module.scss';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function BatchDetailsTableHeader() {
  return (
    <>
      <TableHead className={styles.root}>
        <TableRow>
          <TableCell className={styles.heading}>Preference </TableCell>
          <TableCell className={styles.heading}>Timing </TableCell>
          <TableCell className={styles.heading}>
            Associated Super Batch{' '}
          </TableCell>
          <TableCell className={styles.heading}>Save/Update </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default BatchDetailsTableHeader;
